define('OutSystems/ReactView/convertCssTransitionClassNames',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var convertCssTransitionClassNames = function (cssTransitionBaseName) { return ({
        appear: cssTransitionBaseName + "-appear",
        appearActive: cssTransitionBaseName + "-appear-active",
        appearDone: cssTransitionBaseName + "-appear-done",
        enter: cssTransitionBaseName + "-enter",
        enterActive: cssTransitionBaseName + "-enter-active",
        enterDone: cssTransitionBaseName + "-enter-done",
        exit: cssTransitionBaseName + "-leave",
        exitActive: cssTransitionBaseName + "-leave-active",
        exitDone: cssTransitionBaseName + "-leave-done",
    }); };
    exports.default = convertCssTransitionClassNames;
});
//# sourceMappingURL=convertCssTransitionClassNames.js.map;
